import styled from 'styled-components'

export const StyledLonPageHelper = styled.div`
  background: #f6f8fb;
  display: flex;
  flex-flow: column nowrap;
  justify-content: space-between;
  .flex-row-around {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: space-around !important;

    > div {
      flex: 1;
    }
  }

  p {
    margin: 0;
  }
  a,
  button {
    cursor: pointer;
  }
  .row {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
  }

  .flex-column-center {
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
  }

  .lon-card {
    padding: 0;
    border: 0.5px solid #20203d;
    box-sizing: border-box;
    border-radius: 12px;
    margin-top: 20px;
    background: #373756;

    .flex-row-between {
      padding: 15px 20px;
      background: #2c2c4d;
      &:last-child,
      &:nth-last-child(2) {
        border-bottom-left-radius: 12px;
        border-bottom-right-radius: 12px;
      }
      /* &:last-child {
        background: #373756;
      } */
    }

    &--light {
      background: #fff;
      border: none;

      .flex-row-between {
        background: #fff;
        border: none;
      }

      .button--light,
      a.button--light,
      a.button.button--light {
        background-color: rgba(95, 77, 188, 0.1);
        color: #5f4dbc;
      }

      .button--dark {
        background-color: #5f4dbc;
        color: #fff;
      }
    }

    .divider-wrap {
      background: #2c2c4d;

      &--light {
        background: transparent;

        .divider {
          width: calc(100% - 40px);
          margin: 0 auto;
        }
      }

      .divider {
        width: calc(100% - 40px);
        margin: 0 auto;
      }
    }
  }

  .lon-cell {
    width: 375px;
    height: 105px;
    background: #2c2c4d;
    border: 0.5px solid #373756;
    box-sizing: border-box;
    box-shadow: 0px 4px 20px rgba(57, 53, 92, 0.3);
    border-radius: 12px;
    margin: 10px;
    padding: 25px 24px 28px;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: space-between;
    dd {
      font-size: 14px;
      line-height: 20px;
      color: #ffffff;
      opacity: 0.5;
      margin-bottom: 0;
    }
    dt {
      font-weight: bold;
      font-size: 27px;
      line-height: 27px;
      color: #ffffff;
      margin-top: 10px;
    }
  }

  .flex-row-between,
  .flex-row-around {
    width: 750px;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: space-between;

    &.dually {
      .mobile-divider {
        display: none;
      }
    }

    dd {
      font-size: 11px;
      line-height: 13px;
      color: #9598ab;
      margin-bottom: 0;
    }

    dt {
      font-weight: bold;
      font-size: 17px;
      line-height: 21px;
      color: #ffffff;
      margin-top: 9px;
      margin-bottom: 2px;
    }

    button,
    a.button {
      margin: 0;
      border: 0;
      outline: none;
      height: 32px;
      border-radius: 16px;
      font-size: 15px;
      line-height: 32px;
      text-align: center;
      color: #ffffff;
      background: rgba(255, 255, 255, 0.1);
      padding: 0 15px;
      cursor: pointer;
      white-space: nowrap;
      display: inline-block;

      &.primary {
        background: #5f4dbc;
        height: 36px;
        line-height: 36px;
        border-radius: 18px;
        padding: 0 45px;
      }
    }
  }

  .exchange-header-wrap {
    background: white;
  }

  .normal-wrap {
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    width: 1200px;
  }

  .divider {
    width: 100%;
    height: 1px;
    background: #252548;
    margin: 15px 0;

    &.light {
      background: white;
      opacity: 0.05;
      width: calc(100% - 40px);
    }

    &.gray {
      background-color: rgba(32, 32, 61, 0.1);
    }
  }

  .footer-wrap {
    background: white;
    a {
      text-decoration: none;
    }
  }

  .lon-inner-wrap {
    width: 1200px;
    margin: 0 auto;
    padding: 30px 0 80px;
    flex: 1;
  }
  .sub-nav {
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
  }
  dt.reward-value {
    color: #43454f;
  }
  @media screen and (max-width: 960px) {
    min-height: 100vh;
    .flex-row-between,
    .flex-row-around {
      width: unset;
    }
    .exchange-header-wrap {
      display: none;
    }

    .footer-wrap {
      display: none;
    }

    .lon-inner-wrap {
      width: 100%;
      padding: 0 15px 30px;

      .flex-row-between.dually,
      .flex-row-between.single {
        flex-flow: row wrap;
        > div {
          width: 50%;
        }
        .mobile-divider {
          display: block;
          height: 1px;
          width: 100%;
          background: #20203d;
          margin: 13px 0;
        }
      }

      .lon-card {
        width: 100%;
        > div {
          width: 100%;
        }
      }
      .mine {
        .lon-cell {
          width: 100% !important;
        }
      }
    }

    dt.reward-value {
      color: #43454f;
    }
  }
`

export const StyledTradeWrapper = styled.div`
  color: #43454f;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  padding-top: 120px;
  padding-bottom: 20px;
  .normal-wrap {
    width: 1195px;
    color: #43454f;
    .purple-link {
      font-weight: 500;
      color: #5f55a9;
    }
  }
  dd {
    color: #9598ab;
  }

  .intro {
    width: 100%;

    .intro-header {
      display: flex;
      align-items: center;
      flex-flow: row nowrap;
      margin-bottom: 4px;
    }

    .intro-desc {
      margin-left: 48px;
    }

    dt {
      font-size: 25px;
      line-height: 27px;
      color: #43454f;
    }

    dd {
      font-size: 16px;
      line-height: 24px;
      color: #9aa3ae;
    }
  }

  .mining-data,
  .my-trade,
  .my-invitation,
  .reward-record {
    width: 100%;
    margin-top: 45px;
    .title {
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      justify-content: space-between;
      .to-claim {
        color: #9aa3ae;
        font-weight: 500;
        font-size: 14px;
        padding-right: 8px;
      }
      & > p {
        font-size: 17px;
        line-height: 27px;
        color: #9598ab;
        font-weight: bold;
        padding: 15px 0;
        margin: 0;
      }

      button {
        background: #5f4dbc;
        border-radius: 17px;
        color: white;
        font-size: 17px;
        line-height: 34px;
        color: #ffffff;
        border: 0;
        padding: 0 16px;

        &.secondary {
          color: #5f4dbc;
          background: #e7e7f5;
          margin: 0 10px;
        }
      }

      .group {
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        justify-content: center;

        img {
          margin-right: 10px;
        }
      }
    }
    .cards {
      display: flex;
      flex-flow: row wrap;
      align-items: center;
      justify-content: space-between;
      width: 100%;

      .card {
        background: white;
        border: 0.5px solid #eaecf6;
        box-sizing: border-box;
        border-radius: 12px;
        padding: 30px;

        &:first-child {
          flex: 1;
        }
        &:last-child {
          width: 380px;
          margin-left: 30px;
        }

        dd {
          font-size: 27px;
          line-height: 27px;
          color: #5f4dbc;
          font-weight: bold;
          margin: 10px 0;
        }

        dt {
          font-size: 15px;
          color: #9598ab;
          font-weight: normal;
        }
      }
    }

    .placeholder {
      text-align: center;
      background-color: white;
      padding: 30px;
      border-radius: 12px;
      margin-bottom: 30px;
      margin-top: 10px;
      span {
        font-weight: 500;
        font-size: 15px;
        line-height: 21px;
        color: #9aa3ae;
        &.clickable {
          color: #5f4dbc;
          margin-right: 6px;
          cursor: pointer;
        }
      }
    }
  }

  .reward-record {
    background: white;
    border-radius: 12px;
    padding: 20px 20px 40px;
    border: 0.5px solid #eaecf6;
    .title {
      border-bottom: 0.5px solid #eaecf6;
      p {
        margin: 0;
      }
    }
    .ant-table-thead > tr > th {
      background: white;
      font-size: 13px;
      line-height: 20px;
      color: #9598ab;
    }
  }

  @media screen and (max-width: 960px) {
    padding: 48px 15px 100px;

    .round-popover {
      border-radius: 8px;
      padding-left: 20px;
      padding-right: 20px;
      .ant-tooltip-inner {
        width: calc(100vw - 20px);
        margin-left: -10px;
        border-radius: 8px;
        overflow-x: scroll;
      }
    }

    .normal-wrap {
      width: 100% !important;
      .purple-link {
        display: block;
        margin-top: 12px;
      }
    }

    .intro {
      padding: 10px 0;
      .intro-header {
        margin-bottom: 12px;

        .title {
          font-size: 20px;
          line-height: 27px;
        }
      }

      .intro-desc {
        margin-left: 0;
      }

      dd {
        font-size: 13px;
        line-height: 19px;
        margin: 0 0 10px;
      }
    }

    .mining-data,
    .my-trade {
      .title {
        margin-bottom: 16px;
      }
    }

    .mining-data,
    .my-trade,
    .my-invitation {
      margin-top: 0;
      .title {
        & > p {
          padding: 0;
          font-weight: 500;
        }
      }
      .cards {
        flex-flow: column nowrap;

        & > div {
          margin-bottom: 15px;
        }
        .card {
          width: 100%;
          padding: 25px 20px;
        }
        .card:last-child {
          width: 100%;
          margin-left: 0;
        }
      }
    }

    .reward-record {
      width: 100%;
      padding: 20px 15px;
      margin-top: 0;

      .to-claim-btn {
        font-size: 15px !important;
      }
    }
  }
`

export const StyledWarningWrap = styled.div`
  background-color: rgba(254, 182, 29, 0.1);
  border-radius: 8px;
  padding: 15px;
  margin: 12px 0 15px 0;
  width: 100%;
  text-align: left;
  p {
    font-weight: 500;
    font-size: 13px;
    line-height: 20px;
    color: #ffbe54;
    word-break: break-all;
  }
  span.bold {
    font-weight: 700;
  }
`

export const StyledTitleIcon = styled.img`
  width: 32px;
  height: 32px;
  margin-right: 12px;

  ${({ theme }) => theme.media.sm`
    display: none;
  `}
`

export const StyledFixedBtnWrap = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  padding: 10px 20px 40px 20px;
  background: #fff;
  box-shadow: 0 -0.5px 0 0 rgba(0, 0, 0, 0.2);

  button {
    background: #5f4dbc;
    border-radius: 17px;
    color: white;
    font-size: 17px;
    line-height: 34px;
    color: #ffffff;
    border: 0;
    padding: 0 16px;
    width: 48%;
  }
`

export const StyledGoTradeBtn = styled.button<{ width?: string }>`
  background: #5f4dbc;
  border-radius: 17px;
  color: white;
  font-size: 17px;
  line-height: 34px;
  text-align: center;
  border: 0;
  padding: 0 16px;
  width: ${({ width }) => width ?? 'auto'};
  cursor: pointer;
`
